export default __webpack_public_path__ + "static/media/168.c99207c1.png";